import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import dayjs from "dayjs";
import { GetCustomerSubscriptions } from "@/server-types";
import React from "react";

const getEventTitle = (event: SubscriptionEvent) => {
  switch (event.eventType) {
    case "created":
      return t`Naročnina je bila ustvarjena`;
    case "freezeStart":
      return t`Začetek zamrznitve`;
    case "freezeEnd":
      return t`Konec zamrznitve`;
    case "extension":
      return t`Podaljšanje naročnine`;
  }
};

const getEventDescription = (event: SubscriptionEvent) => {
  switch (event.eventType) {
    case "created":
      return t`Naročnina je bila dodeljena stranki.`;
    case "freezeStart":
      return t`Naročnina je bila zamrznjena.`;
    case "freezeEnd":
      return t`Zamrznitev naročnine se je končala.`;
    case "extension":
      return t`Naročnina je bila podaljšana do ${dayjs(event.newValidTo).format("DD.MM.YYYY")}.`;
    default:
      return null;
  }
};

export type SubscriptionEvent =
  GetCustomerSubscriptions["response"]["customerSubscriptionsWithUsage"][number]["events"][number];

interface CustomerSubscriptionEventsModalProps {
  isOpen: boolean;
  onClose: () => void;
  events: SubscriptionEvent[];
}

export const CustomerSubscriptionEventsModal: React.FC<
  CustomerSubscriptionEventsModalProps
> = ({ isOpen, onClose, events }) => {
  console.log("Events", events);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>
          <Trans>Zgodovina sprememb</Trans>
        </ModalHeader>
        <ModalBody>
          <>
            {events.map((event) => (
              <div
                key={event.id}
                className="rounded-md border-1 border-gray-200 p-2"
              >
                <div className="flex items-center gap-2">
                  <p className="text-xs text-gray-500">
                    {dayjs(event.eventDate).format("DD.MM.YYYY")}
                  </p>
                  <h2 className="text-sm font-medium">
                    {getEventTitle(event)}
                  </h2>
                </div>
                <p className="text-sm text-gray-500">
                  {getEventDescription(event)}
                </p>
              </div>
            ))}
          </>
        </ModalBody>
        <ModalFooter>
          <Button onPress={onClose}>
            <Trans>Zapri</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
